/**
 * Formspree integration helper.
 * Submits form data to the Formspree endpoint in addition to our backend persistence.
 * Resilient: failures are swallowed so the backend save still controls the UX flow.
 */
export const FORMSPREE_ENDPOINT = "https://formspree.io/f/mwvzvlqa";

export async function submitToFormspree(payload) {
    try {
        const res = await fetch(FORMSPREE_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(payload),
        });
        return res.ok;
    } catch {
        return false;
    }
}
